import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
//import { Idle } from '@ng-idle/core';
import { AuthorizationService } from '../authorization.service';
import { AuthService } from './auth.service';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent {
  errorMessage: string;
  pageTitle = 'Log In';

  constructor(private authService: AuthService, public authorizationService: AuthorizationService) { }
  
  ngOnInit() {
    if (!this.authService.isLoggedIn){
      if (!this.authService.redirectUrl)
        this.authService.redirectUrl='/license';
//      this.authService.azureLogin();
      this.authorizationService.authorize();
    }
  }

  login(loginForm: NgForm) {
     if (loginForm && loginForm.valid) {
      const userName = loginForm.form.value.userName;
      const password = loginForm.form.value.password;
      this.authService.login(userName, password); 
 //     console.log('redirectUrl: '+this.authService.redirectUrl);
    } else {
      this.errorMessage = 'Please enter a user name and password.';
    }
  }
}
